import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import MuiTabs from '../../components/MuiTabs';
import InsuranceList from "./list";
import DraftsIcon from '@mui/icons-material/Drafts';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


function InsuranceListTabs() {
    const [activeTab, setActiveTab] = useState(0);

    const tabHeaders = [
        {
            label: "Draft", key: "0", icon: <DraftsIcon color="primary" />
        },
        {
            label: "Approved", key: "1", icon: <CheckCircleIcon color="primary" />
        },
        {
            label: "Rejected", key: "2", icon: <CancelIcon color="primary" />
        },

    ];
    return (
        <>
            <Grid item xs={12} md={4}>
                <Box sx={{ width: '100%', bgcolor: '#fff', boxShadow: 1 }}>
                    <MuiTabs
                        tabs={tabHeaders}
                        active={activeTab}
                        setActive={setActiveTab}
                        sx={{
                            '& .MuiTab-root': {
                                marginRight: '24px', // Increase the gap between tabs
                                minWidth: '150px', // Optional: Set a minimum width for each tab
                            }
                        }}

                    />
                </Box>
            </Grid>
            {activeTab === 0 && (
                <Grid item xs={12}>
                    <InsuranceList status="DRAFT" />
                </Grid>
            )}
            {activeTab === 1 && (
                <Grid item xs={12}>
                    <InsuranceList status={["APPROVED", "CERTIFICATE_GENERATED"]} />
                </Grid>
            )}
            {activeTab === 2 && (
                <Grid item xs={12}>
                    <InsuranceList status="CANCEL" />
                </Grid>
            )}
        </>
    )
}

export default InsuranceListTabs;